<button
  #trigger
  type="button"
  [id]="fieldId()"
  [value]="color()"
  [attr.aria-label]="accessibleName()"
  [attr.aria-describedby]="fieldId() + '-description'"
  class="tw-flex tw-items-center tw-gap-4 tw-w-full tw-p-4 tw-text-left tw-bg-white tw-border tw-border-solid tw-border-gray-200 tw-rounded-lg tw-cursor-pointer hover:tw-bg-gray-50"
  (input)="onColorInput()"
>
  <span
    class="tw-pointer-events-none tw-flex-none tw-w-10 tw-h-10 tw-rounded-full tw-box-border tw-border tw-border-gray-400"
    [class.tw-border-solid]="!!color()"
    [class.tw-border-dashed]="!color()"
    [style.background-color]="color() || null"
    aria-hidden="true"
  ></span>
  <span class="tw-pointer-events-none tw-flex tw-flex-col tw-gap-1 tw-min-w-0">
    <span class="tw-font-semibold tw-text-gray-900">{{ label() }}</span>
    <span
      [id]="fieldId() + '-description'"
      class="tw-text-gray-600 tw-break-words"
      >{{ description() }}</span
    >
  </span>
</button>
